import React, { useState, useEffect } from 'react';
import { unwrapResult } from '@reduxjs/toolkit';
import Button from 'react-bootstrap/Button'
import { Confirm } from 'react-st-modal';
import { DeleteAnnotations } from '../Api/AnnotationApi'
import { UpdateAnnotationProperties } from '../Api/AnnotationPropertiesApi'
import { EditAnnotationProperties } from '../ProjectsPage/EditAnnotationProperties'
import { StyleSheetsDialog } from '../ProjectsPage/StyleSheetsDialog'
import { PropertyTemplatesView } from '../ProjectsPage/PropertyTemplatesView'
import { ToastClose, ToastError, ToastLoading } from './ToastDisplay';
import { RiFilterLine, RiFilterOffLine } from "react-icons/ri";
import '../css/annotation-table.css'

import { CopyAnnotationsAround } from './CopyAnnotationsAround.js';

import { kaReducer, Table } from 'ka-table';
import { DataType, FilteringMode, SortingMode, ActionType, SortDirection } from 'ka-table/enums';
import {
    deselectAllFilteredRows, deselectRow,
    selectAllFilteredRows, selectRow, selectRowsRange,
    loadData, updateData, setSingleAction,
    updateFilterRowValue, updateEditorValue,
    updateFilterRowOperator,
    showColumn
} from 'ka-table/actionCreators';

import { saveAs } from 'file-saver';

import { CanWriteAnnotationSet, CanEditAnnotationTemplatesOrStyleSheets } from '../App/UserPermissions'
import { fullUsersName } from '../App/Utils'
import { kaPropsUtils } from 'ka-table/utils';
import { newRowId } from "ka-table/const";
import { v4 as uuid } from "uuid";
import { BsLockFill } from "react-icons/bs";
import { CSVLink } from 'react-csv';
import * as Constants from '../constants.js';
import Select from 'react-select'
import '../css/table-style.scss'
import { BeaconDialogMap } from '../Components/BeaconDialogMap';

import { Logger } from 'aws-amplify';
import { property } from 'three/tsl';
const logger = new Logger('AnnotationTable');


const deleteAnnotationsToastId = 1;
const updatePropertiesToastId = 6;


function ListDropDown(props) {

    const customStyles = {
        option: (provided, state) => ({
            ...provided,
        }),
        control: (provided) => ({
            ...provided,
        }),
        singleValue: (provided, state) => ({
            ...provided
        }),
        menuPortal: base => ({ ...base, zIndex: 9999 }),
        clearIndicator: (provided) => ({
            ...provided,
            padding: 0
        })
    }
    return (
        <Select
            menuPortalTarget={document.body}
            styles={customStyles}
            value={props.items}
            onChange={props.setItems}
            closeMenuOnSelect={props.multiSelect ? false : true}
            name="parameterList"
            className="list-property-select"
            isMulti={props.multiSelect}
            placeholder={props.multiSelect ? "Select Item(s)..." : "Select Item..."}
            options={props.availableItems} />
    );
}

const ListCell = (props) => {

    let items;
    if (props?.value?.valid === false) {
        items =
            <>
                {"---"}
            </>

    }
    else if (props?.value?.empty) {
        items =
            <div className={"empty-cell"}>
                {"[Empty]"}
            </div >
    }
    else {
        items = props?.value?.items?.length > 0 ? props?.value?.items.map((item) =>
            <div key={uuid()} className={"me-1 mt-1 p-0 ps-1 pe-1 rounded border border-light bg-primary text-white"}>
                {item.label}
            </div>
        ) : <>[Empty]</>
    }

    return (
        <div className={"annotationPropertyItemContainer"}>
            <div className="d-flex flex-wrap ps-0 text-black">
                {items}
            </div>
        </div>
    );
};

const ValueCell = (props) => {

    if (props?.value?.valid === false) {
        return (
            <>
                {"---"}
            </>
        );
    }
    else if (props?.value?.empty) {
        return (
            <div className={"empty-cell"}>

                {"[Empty]"}
            </div>
        );
    }

    if (props.column.propertyType === "number") {

        return (
            <>
                {props?.value?.value}
            </>
        );
    }
    else {
        return (
            <>
                {props?.value?.value}
            </>
        );
    }
};


const SelectionCell = (props) => {


    return (
        <>
            <input
                type='checkbox'
                checked={props.isSelectedRow}
                onChange={(event) => {
                    if (event.nativeEvent.shiftKey) {
                        props.dispatch(selectRowsRange(props.rowKeyValue, [...props.selectedRows].pop()));
                    } else if (event.currentTarget.checked) {
                        props.dispatch(selectRow(props.rowKeyValue));
                    } else {
                        props.dispatch(deselectRow(props.rowKeyValue));
                    }
                }}
            />
            {props.value && <BsLockFill className="ms-1 mb-2" />}
        </>
    );
};

const SelectionHeader = ({ dispatch, areAllRowsSelected }) => {
    return (
        <input
            type='checkbox'
            checked={areAllRowsSelected}
            onChange={(event) => {
                if (event.currentTarget.checked) {
                    dispatch(selectAllFilteredRows()); // also available: selectAllVisibleRows(), selectAllRows()
                } else {
                    dispatch(deselectAllFilteredRows()); // also available: deselectAllVisibleRows(), deselectAllRows()
                }
            }}
        />
    );
};


const FilterOperators = ({
    column, dispatch,
}) => {
    if ((column?.propertyTemplate?.PropertyType === 0 && column?.propertyTemplate?.ValueType === 0) ||
        column.propertyType === "string") {
        //text cell
        return (
            <select
                className='annotation-table-filter-operator-text'
                defaultValue={column.filterRowOperator}
                onChange={(event) => {
                    dispatch(updateFilterRowOperator(column.key, event.currentTarget.value));
                    if (event.currentTarget.value === "empty" ||
                        event.currentTarget.value === "notempty" ||
                        event.currentTarget.value === "nofilter" ||
                        event.currentTarget.value === "present" ||
                        event.currentTarget.value === "notpresent") {
                        dispatch(updateFilterRowValue(column.key, " "));
                    }
                }}>
                <option value={'nofilter'}>{'Not Filtered'}</option>
                <option value={'='}>{'='}</option>
                <option value={'!'}>{'!='}</option>
                <option value={'contains'}>{'Contains'}</option>
                <option value={'not contains'}>{'! Contains'}</option>
                <option value={'empty'}>{'Empty'}</option>
                <option value={'notempty'}>{'Not Empty'}</option>
                <option value={'present'}>{'Defined'}</option>
                <option value={'notpresent'}>{'Not Defined'}</option>
            </select>
        );
    }
    else if (column?.propertyType === "list") {
        //multi list
        if (column.filterRowValue.multiSelect) {
            return (
                <select
                    className='annotation-table-filter-operator-text'
                    defaultValue={column.filterRowOperator}
                    onChange={(event) => {
                        dispatch(updateFilterRowOperator(column.key, event.currentTarget.value));
                        if (event.currentTarget.value === "empty" ||
                            event.currentTarget.value === "notempty" ||
                            event.currentTarget.value === "nofilter" ||
                            event.currentTarget.value === "present" ||
                            event.currentTarget.value === "notpresent") {
                            dispatch(updateFilterRowValue(column.key, { ...column.filterRowValue, items: [] }));
                        }
                    }}>
                    <option value={'nofilter'}>{'Not Filtered'}</option>
                    <option value={'='}>{'='}</option>
                    <option value={'!='}>{'!='}</option>
                    <option value={'anyof'}>{'Any Of'}</option>
                    <option value={'allof'}>{'All Of'}</option>
                    <option value={'noneof'}>{'None Of'}</option>
                    <option value={'empty'}>{'Empty'}</option>
                    <option value={'notempty'}>{'Not Empty'}</option>
                    <option value={'present'}>{'Defined'}</option>
                    <option value={'notpresent'}>{'Not Defined'}</option>
                </select>
            );
        }
        else {
            //single select list
            return (
                <select
                    className='annotation-table-filter-operator-text'
                    defaultValue={column.filterRowOperator}
                    onChange={(event) => {
                        dispatch(updateFilterRowOperator(column.key, event.currentTarget.value));
                        if (event.currentTarget.value === "empty" ||
                            event.currentTarget.value === "notempty" ||
                            event.currentTarget.value === "nofilter" ||
                            event.currentTarget.value === "present" ||
                            event.currentTarget.value === "notpresent") {
                            dispatch(updateFilterRowValue(column.key, { ...column.filterRowValue, items: null }));
                        }

                    }}>
                    <option value={'nofilter'}>{'Not Filtered'}</option>
                    <option value={'='}>{'='}</option>
                    <option value={'!='}>{'!='}</option>
                    <option value={'empty'}>{'Empty'}</option>
                    <option value={'notempty'}>{'Not Empty'}</option>
                    <option value={'anyof'}>{'Any Of'}</option>
                    <option value={'noneof'}>{'None Of'}</option>
                    <option value={'present'}>{'Defined'}</option>
                    <option value={'notpresent'}>{'Not Defined'}</option>
                </select>
            );

        }
    }
    else if (column?.dataType === "date") {
        return (
            <select
                className='annotation-table-filter-operator-text'
                defaultValue={column.filterRowOperator}
                onChange={(event) => {
                    dispatch(updateFilterRowOperator(column.key, event.currentTarget.value));
                    if (event.currentTarget.value === "nofilter") {
                        dispatch(updateFilterRowValue(column.key, null));
                    }

                }}>
                <option value={'nofilter'}>{'Not Filtered'}</option>
                <option value={'='}>{'='}</option>
                <option value={'>'}>{'>'}</option>
                <option value={'>='}>{'>='}</option>
                <option value={'<'}>{'<'}</option>
                <option value={'<='}>{'<='}</option>
            </select>
        );

    }
    else {
        //number
        return (
            <select
                className='annotation-table-filter-operator-text'
                defaultValue={column.filterRowOperator}
                onChange={(event) => {
                    dispatch(updateFilterRowOperator(column.key, event.currentTarget.value));
                    if (event.currentTarget.value === "notempty" ||
                        event.currentTarget.value === "empty" ||
                        event.currentTarget.value === "present" ||
                        event.currentTarget.value === "notpresent") {
                        dispatch(updateFilterRowValue(column.key, 0));
                    }
                    column.stopFiltering = false;
                }}>
                <option value={'nofilter'}>{'Not Filtered'}</option>
                <option value={'='}>{'='}</option>
                <option value={'!'}>{'!='}</option>
                <option value={'>'}>{'>'}</option>
                <option value={'>='}>{'>='}</option>
                <option value={'<'}>{'<'}</option>
                <option value={'<='}>{'<='}</option>
                <option value={'notempty'}>{'Not Empty'}</option>
                <option value={'empty'}>{'Empty'}</option>
                <option value={'present'}>{'Defined'}</option>
                <option value={'notpresent'}>{'Not Defined'}</option>
            </select>
        );

    };

};

//for filtering a list property
const FilterList = ({
    column, dispatch,
}) => {

    function setItems(items) {
        if (column.filterRowValue.multiSelect || column.filterRowOperator === "anyof" || column.filterRowOperator === "noneof") {
            dispatch(updateFilterRowValue(column.key, { ...column.filterRowValue, items: items }));
        }
        else {
            //single doesn't return an array, so arrayerise it
            dispatch(updateFilterRowValue(column.key, { ...column.filterRowValue, items: [items] }));
        }
    }

    return (
        <div className="annotation-table-filter-container-list">
            <FilterOperators column={column} dispatch={dispatch} />
            {!(column.filterRowOperator === "empty" ||
                column.filterRowOperator === "notempty" ||
                column.filterRowOperator === "nofilter" ||
                column.filterRowOperator === "present" ||
                column.filterRowOperator === "notpresent") &&
                <ListDropDown items={column.filterRowValue.items} multiSelect={column.filterRowValue.multiSelect || column.filterRowOperator === "anyof" || column.filterRowOperator === "noneof"} availableItems={column.filterRowValue.availableItems} setItems={setItems} />
            }
        </div>
    );
};


//for filtering a number property
const FilterNumber = ({
    column, dispatch,
}) => {
    return (
        <div className="annotation-table-filter-container">
            <FilterOperators column={column} dispatch={dispatch} />
            {!(column.filterRowOperator === "empty" ||
                column.filterRowOperator === "notempty" ||
                column.filterRowOperator === "nofilter" ||
                column.filterRowOperator === "present" ||
                column.filterRowOperator === "notpresent") &&
                <input
                    defaultValue={column.filterRowValue}
                    className="annotation-table-filter-number"
                    onChange={(event) => {
                        const filterRowValue = event.currentTarget.value !== '' ? Number(event.currentTarget.value) : null;
                        dispatch(updateFilterRowValue(column.key, filterRowValue));
                    }}
                    type='number'
                />}
        </div>
    );
};

const FilterDate = ({
    column, dispatch,
}) => {
    return (
        <div className="annotation-table-filter-container">
            <FilterOperators column={column} dispatch={dispatch} />
            {!(column.filterRowOperator === "empty" ||
                column.filterRowOperator === "notempty" ||
                column.filterRowOperator === "nofilter") &&
                <input
                    type='date'
                    className="annotation-table-filter-date"
                    onChange={(event) => {
                        const targetValue = event.currentTarget.value;
                        const filterRowValue = targetValue ? new Date(targetValue) : null;
                        dispatch(updateFilterRowValue(column.key, filterRowValue));
                    }}
                />
            }
        </div>
    );
};

const FilterText = ({
    column, dispatch,
}) => {

    return (
        <div className="annotation-table-filter-container">
            <FilterOperators column={column} dispatch={dispatch} />
            {!(column.filterRowOperator === "empty" ||
                column.filterRowOperator === "notempty" ||
                column.filterRowOperator === "nofilter" ||
                column.filterRowOperator === "present" ||
                column.filterRowOperator === "notpresent") &&
                <input
                    value={column.filterRowValue}
                    className="annotation-table-filter-text"
                    onChange={(event) => {
                        dispatch(updateFilterRowValue(column.key, event.currentTarget.value));
                    }}
                    type='text'
                />
            }
        </div>
    );
};

function getUserName(orgs, userId) {

    if (!userId || userId === "00000000-0000-0000-0000-000000000000") return "---";

    for (let orgIndex = 0; orgIndex < orgs.length; orgIndex++) {
        var user = orgs[orgIndex].Users.find(u => u.UserId === userId);
        if (user) {
            return fullUsersName(user, orgs, true);
        }
    }
    return "Unknown";
}


//----------------------------------------------------------------
//----------------------------------------------------------------
//----------------------------------------------------------------
//----------------------------------------------------------------
//----------------------------------------------------------------
//----------------------------------------------------------------
//table start
//----------------------------------------------------------------
export function AnnotationTable(props) {

    const { project, model, annotationSet, currentUser, orgsInfo, helpContext } = props;

    logger.debug("AnnotationTable(props)", props);


    function getDataItem(annotation) {
        let item =
        {
            id: annotation.AnnotationId,
            rowAnnotation: annotation,
            dateCreated: annotation.DateCreated,
            dateChanged: Date.parse(annotation.DateUpdated) > 0 ? annotation.DateUpdated : "",
            userCreated: { value: getUserName(orgsInfo.organisations, annotation.UserCreated) },
            userChanged: { value: getUserName(orgsInfo.organisations, annotation.UserUpdated) }
        };

        for (let index = 0; index < project?.PropertyTemplates?.length; index++) {

            //does this annotation have one of these?, if not show a '---' text
            const anProp = annotation?.Properties.find(prop => prop.PropertyTemplate.PropertyTemplateId === project?.PropertyTemplates[index].PropertyTemplateId);

            if (project?.PropertyTemplates[index].PropertyType === Constants.propertyType.Value) {
                if (project?.PropertyTemplates[index].ValueType !== Constants.valueType.TextProperty) {
                    //number - can't use text - it gets converted to a number
                    if (anProp) {
                        if (anProp.Value === "" || anProp.Value === null) {
                            //no number entered
                            item["property" + project?.PropertyTemplates[index].PropertyTemplateId.replaceAll('-', '')] = {
                                valid: true,
                                empty: true,
                                value: NaN
                            };
                        }
                        else {
                            item["property" + project?.PropertyTemplates[index].PropertyTemplateId.replaceAll('-', '')] = {
                                valid: true,
                                empty: false,
                                value: anProp.Value
                            };
                        }

                        dispatchTable(showColumn("property" + project?.PropertyTemplates[index].PropertyTemplateId.replaceAll('-', ''))); //hide the column if it is a number
                    }
                    else {
                        //no property entered
                        item["property" + project?.PropertyTemplates[index].PropertyTemplateId.replaceAll('-', '')] = {
                            valid: false,
                            empty: false,
                            value: null
                        };
                    }
                }
                else {
                    //text
                    if (anProp) {
                        if (anProp.Value === "" || anProp.Value === null) {
                            //nothing entered
                            item["property" + project?.PropertyTemplates[index].PropertyTemplateId.replaceAll('-', '')] = {
                                valid: true,
                                empty: true,
                                value: null
                            };
                        }
                        else {
                            item["property" + project?.PropertyTemplates[index].PropertyTemplateId.replaceAll('-', '')] = {
                                valid: true,
                                empty: false,
                                value: anProp.Value
                            };
                        }
                        dispatchTable(showColumn("property" + project?.PropertyTemplates[index].PropertyTemplateId.replaceAll('-', ''))); //hide the column if it is a number

                    }
                    else {
                        //no property entered
                        item["property" + project?.PropertyTemplates[index].PropertyTemplateId.replaceAll('-', '')] = {
                            valid: false,
                            empty: false,
                            value: null
                        };
                    }
                }
            }
            else {
                if (anProp) {
                    item["property" + project?.PropertyTemplates[index].PropertyTemplateId.replaceAll('-', '')] =
                    {
                        valid: true,
                        empty: anProp.Items?.length === 0,
                        items: anProp.Items.map(
                            item => ({
                                label: item.ItemText,
                                value: item.ListPropertyTemplateListItemId
                            })
                        )
                    }
                    dispatchTable(showColumn("property" + project?.PropertyTemplates[index].PropertyTemplateId.replaceAll('-', ''))); //hide the column if it is a number

                }
                else {
                    item["property" + project?.PropertyTemplates[index].PropertyTemplateId.replaceAll('-', '')] =
                    {
                        valid: false,
                        empty: false,
                        items: []
                    }
                }
            }
        }


        return item;

    }

    function dataArray(annotationSet) {
        return annotationSet?.Annotations?.map((annotation, index) => (getDataItem(annotation)));
    }


    //for the properties edit modal
    const [showPropertiesDialog, setShowPropertiesDialog] = useState(false);
    const [showPropertyTemplatesDialog, setShowPropertyTemplatesDialog] = useState(false);
    const [annotationPropertiesParam, setAnnotationPropertiesParam] = useState({});
    const [showStyleSheetsDialog, setShowStyleSheetsDialog] = useState(false);
    const [showCopyAnnotations, setShowCopyAnnotations] = useState(false);

    const [filterVisible, setFilterVisible] = useState(false);
    function onToggleFilter() {
        if (filterVisible) {
            logger.debug("clear filters");
            //clear filters
            tablePropsInit().columns.forEach((column) => {
                if (column?.propertyType === "list") {
                    column.filterRowValue.items = [];
                    dispatchTable(updateFilterRowValue(column.key, column.filterRowValue));
                }
                else {
                    dispatchTable(updateFilterRowValue(column.key, ""));
                }
            })
        }
        setFilterVisible(!filterVisible);
    }


    function tablePropsInit() {
        let tablePropObj = {

            columns: [
                { key: 'selection', isEditable: false, width: 45, propertyType: "selection" },
                { key: 'id', title: 'ID', dataType: DataType.String, style: { width: 150 }, isEditable: false, visible: false, propertyType: "string" },
            ],
            singleAction: loadData(),
            rowKeyField: 'id',
            sortingMode: SortingMode.Single,
            columnResizing: true,
            selectedRows: [],
            loading: { enabled: false },
            filteringMode: FilteringMode.FilterRow,
            format: ({ column, value }) => {
                if (column.dataType === DataType.Date) {
                    return <>
                        {new Date(value)?.toLocaleDateString()} {new Date(value)?.toLocaleTimeString()}
                    </>
                }
            },
            sort: ({ column }) => {

                logger.info("### sort column", column);
                if (column.propertyType === "list") {
                    //sort on first item
                    return (a, b) => {


                        //valid values are higher than non valid values
                        if ((!a?.valid || a?.empty) && (b?.valid && !b?.empty)) {
                            return 1;
                        }

                        //valid values are higher than non valid values
                        if ((a?.valid && !a?.empty) && (!b?.valid || b?.empty)) {
                            return -1;
                        }


                        let first = a?.items[0]?.label ? a.items[0].label : "";
                        let second = b?.items[0]?.label ? b.items[0].label : "";

                        if (first === second) {
                            return 0;
                        }

                        return first.localeCompare(second) < 0
                            ? column.sortDirection === SortDirection.Ascend ? -1 : 1
                            : column.sortDirection === SortDirection.Ascend ? 1 : -1;

                    }
                }
                else if (column.propertyType === "number") {
                    return (a, b) => {

                        //valid values are higher than non valid values
                        if ((!a?.valid || a?.empty) && (b?.valid && !b?.empty)) {
                            return 1;
                        }

                        //valid values are higher than non valid values
                        if ((a?.valid && !a?.empty) && (!b?.valid || b?.empty)) {
                            return -1;
                        }

                        let first = a?.value ? Number(a.value) : 0;
                        let second = b?.value ? Number(b.value) : 0;

                        if (first === second) {
                            return 0;
                        }

                        return first < second
                            ? column.sortDirection === SortDirection.Ascend ? -1 : 1
                            : column.sortDirection === SortDirection.Ascend ? 1 : -1;

                    };
                }
                else if (column.propertyType === "string") {

                    return (a, b) => {

                        //valid values are higher than non valid values
                        if ((!a?.valid || a?.empty) && (b?.valid && !b?.empty)) {
                            return 1;
                        }

                        //valid values are higher than non valid values
                        if ((a?.valid && !a?.empty) && (!b?.valid || b?.empty)) {
                            return -1;
                        }


                        let first = a?.value ? a.value : "";
                        let second = b?.value ? b.value : "";

                        if (first === second) {
                            return 0;
                        }

                        return first.localeCompare(second) < 0
                            ? column.sortDirection === SortDirection.Ascend ? -1 : 1
                            : column.sortDirection === SortDirection.Ascend ? 1 : -1;

                    };
                }
            },
            filter: ({ column }) => {

                if (column.dataType === DataType.Date) {
                    if (column.filterRowOperator === "nofilter") {
                        return (value, filterRowValue) => true;
                    }
                }
                else if (column.propertyType === "number") {

                    switch (column.filterRowOperator) {
                        case "nofilter":
                            return (value, filterRowValue, rowData) => true;
                        case "=":
                            return (value, filterRowValue, rowData) => { return value?.valid ? Number(filterRowValue) === Number(value?.value) : false; };
                        case ">":
                            return (value, filterRowValue, rowData) => { return value?.valid ? Number(value?.value) > Number(filterRowValue) : false; };
                        case "<":
                            return (value, filterRowValue, rowData) => { return value?.valid ? Number(value?.value) < Number(filterRowValue) : false; };
                        case ">=":
                            return (value, filterRowValue, rowData) => { return value?.valid ? Number(value?.value) >= Number(filterRowValue) : false; };
                        case "<=":
                            return (value, filterRowValue, rowData) => { return value?.valid ? Number(value?.value) <= Number(filterRowValue) : false; };
                        case "!":
                            return (value, filterRowValue, rowData) => { return value?.valid ? Number(value?.value) !== Number(filterRowValue) : false; };
                        case "empty":
                            return (value, filterRowValue, rowData) => { return value?.valid ? value?.empty : false; };
                        case "notempty":
                            return (value, filterRowValue, rowData) => { return value?.valid ? !value?.empty : false; };
                        case "present":
                            return (value, filterRowValue, rowData) => { return value?.valid; };
                        case "notpresent":
                            return (value, filterRowValue, rowData) => { return !value?.valid; };
                        default:
                            break;
                    }
                }
                //text
                else if (column.propertyType === "string") {

                    switch (column.filterRowOperator) {
                        case "nofilter":
                            return (value, filterRowValue) => true;
                        case "contains":
                            return (value, filterRowValue, rowData) => { return value?.valid ? value?.value?.toUpperCase()?.includes(filterRowValue.toUpperCase()) : false; };
                        case "not contains":
                            return (value, filterRowValue, rowData) => { return value?.valid ? !value?.value?.toUpperCase()?.includes(filterRowValue.toUpperCase()) : false; };
                        case "=":
                            return (value, filterRowValue, rowData) => { return value?.valid ? value?.value?.toUpperCase() === filterRowValue?.toUpperCase() : false; };
                        case "!":
                            return (value, filterRowValue, rowData) => { return value?.valid ? value?.value?.toUpperCase() !== filterRowValue?.toUpperCase() : false; };
                        case "empty":
                            return (value, filterRowValue, rowData) => { return value?.valid ? value?.empty : false; };
                        case "notempty":
                            return (value, filterRowValue, rowData) => { return value?.valid ? !value?.empty : false; };
                        case "present":
                            return (value, filterRowValue, rowData) => { return value?.valid; };
                        case "notpresent":
                            return (value, filterRowValue, rowData) => { return !value?.valid; };
                        default:
                            break;
                    }
                }
                else if (column.propertyType === "list") {
                    //lists

                    return (value, filterRowValue, rowData) => {

                        if (column.filterRowOperator === "nofilter") {
                            return true;
                        }
                        else if (!value?.valid) {
                            return (column.filterRowOperator === "notpresent");
                        }
                        else if (value?.valid && column.filterRowOperator === "present") {
                            return true;
                        }

                        //anything else is false if this property not present
                        else {

                            switch (column.filterRowOperator) {
                                case "allof":
                                    let isFound = true;

                                    if (value) {
                                        filterRowValue?.items?.forEach(filterItem => {
                                            if (value?.items.findIndex(valueItem => valueItem.value === filterItem.value) === -1) {
                                                isFound = false;
                                            }
                                        });
                                    }

                                    return isFound;
                                case "anyof":
                                    let foundAny = false;

                                    if (value) {
                                        filterRowValue?.items?.forEach(filterItem => {
                                            if (value?.items.findIndex(valueItem => valueItem.value === filterItem.value) > -1) {
                                                foundAny = true;
                                            }
                                        });
                                    }

                                    return foundAny;
                                case "noneof":
                                case "!=":
                                    let contains = false;

                                    if (value) {
                                        filterRowValue?.items?.forEach(filterItem => {
                                            if (value?.items.findIndex(valueItem => valueItem.value === filterItem.value) > -1) {
                                                contains = true;
                                            }
                                        });
                                    }

                                    return !contains;
                                case "=":
                                    let allFound = true;

                                    if (value && filterRowValue?.items) {
                                        filterRowValue?.items?.forEach(filterItem => {
                                            if (value?.items.findIndex(valueItem => valueItem.value === filterItem.value) === -1) {
                                                allFound = false;
                                            }
                                        });
                                        value?.items?.forEach(valueItem => {
                                            if (filterRowValue.items.findIndex(filterItem => valueItem.value === filterItem.value) === -1) {
                                                allFound = false;
                                            }
                                        });
                                    }

                                    return allFound;
                                case "empty":
                                    if (!value?.items?.length) {
                                        return true;
                                    }
                                    else {
                                        return false;
                                    }
                                case "notempty":
                                    if (!value?.items?.length) {
                                        return false;
                                    }
                                    else {
                                        return true;
                                    }
                                default:
                                    break;



                            }
                        }
                    }
                }

            }
        }

        //add annotation property templates
        for (let index = 0; index < project?.PropertyTemplates?.length; index++) {
            const template = project.PropertyTemplates[index];

            logger.debug("adding col");

            let col = {
                key: "property" + template.PropertyTemplateId.replaceAll('-', ''),
                isEditable: false,
                title: template.Title,
                width: 150,
                filterRowOperator: 'nofilter',
                filterRowValue: "",
                visible: false,
                dataType: DataType.Object
            }

            //text items 
            if (template.PropertyType === 0 && template?.ValueType === Constants.valuePropertyTypeType.Text) {
                col.propertyType = "string";

            }
            else if (template.PropertyType === 0 && template?.ValueType > 0) {
                col.propertyType = "number";
            }

            //lists have an object the filter value
            if (template.PropertyType === 1) {
                col.filterRowValue = {
                    items: [],
                    multiSelect: template.MultiSelect,
                    availableItems: template.ListItems.map(item => ({
                        label: item.ItemText,
                        value: item.ListPropertyTemplateListItemId
                    }))
                };
                col.propertyType = "list";
            }

            tablePropObj.columns.push(col);
        }

        //add paging if > 1000 rows
        if (annotationSet?.Annotations?.length > 1000) {
            tablePropObj.paging =
            {
                enabled: true,
                pageSize: 1000,
                pageIndex: 0
            };
        }

        //meta info
        tablePropObj.columns.push({
            key: 'dateCreated',
            title: "Created",
            isEditable: false,
            dataType: DataType.Date,
            filterRowOperator: 'nofilter',
            style: {
                width: 150,
                minWidth: 100
            }
        });
        tablePropObj.columns.push({
            key: 'dateChanged',
            title: "Last modified",
            isEditable: false,
            dataType: DataType.Date,
            filterRowOperator: 'nofilter',
            style: {
                width: 150,
                minWidth: 100
            }
        });
        tablePropObj.columns.push({
            key: 'userCreated',
            title: "Created by",
            filterRowOperator: 'nofilter',
            isEditable: false,
            dataType: DataType.String,
            propertyType: "string",
            style: {
                width: 150,
                minWidth: 100
            }
        });
        tablePropObj.columns.push({
            key: 'userChanged',
            title: "Modified by",
            filterRowOperator: 'nofilter',
            isEditable: false,
            dataType: DataType.String,
            propertyType: "string",
            style: {
                width: 150,
                minWidth: 100
            }
        });


        return tablePropObj;
    };

    const [tableProps, setTableProps] = useState(tablePropsInit());

    ///reducer ==================================
    ///======= ==================================
    const dispatchTable = async (action) => {

        //built-in actions
        setTableProps((prevState) => kaReducer(prevState, action));

        if (action.type === ActionType.LoadData) {
            dispatchTable(updateData(dataArray(annotationSet)));
        }
        else if (action.type === ActionType.ShowNewRow) {
            //add defaults
            dispatchTable(updateEditorValue(newRowId, "backgroundColour", "FFFFFFFF"));
            dispatchTable(updateEditorValue(newRowId, "foregroundColour", "000000FF"));
        }
    };


    const currentAnSet = React.useRef(null);


    //load data if annotationSet contents have changed
    //init table if annotationset is a different one
    useEffect(() => {

        logger.debug("useEffect");

        if (currentAnSet.current !== annotationSet?.AnnotationSetId) {
            logger.debug("anset id changed ");
            currentAnSet.current = annotationSet?.AnnotationSetId;
            setTableProps(tablePropsInit());
            dispatchTable(setSingleAction(loadData()));

            if (filterVisible) {
                onToggleFilter();
            }

        }
        else {
            logger.debug("anset id NO change ");
            dispatchTable(setSingleAction(loadData()));
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [annotationSet])

    //load data if annotationSet or PropertyTemplates have changed
    useEffect(() => {

        logger.debug("useEffect project?.PropertyTemplates");

        setTableProps(tablePropsInit());
        dispatchTable(setSingleAction(loadData()));

        if (filterVisible) {
            onToggleFilter();
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [project?.PropertyTemplates])



    async function onDeleteSelected() {

        const selectedData = kaPropsUtils.getSelectedData(tableProps);
        if (selectedData.length > 0) {

            const result = await Confirm("Are you sure you want to delete the selected Annotations ?", "Delete Annotations");
            if (result) {

                //get array of annotation ids
                let annotationIds = selectedData.map(item => item.id);

                ToastLoading("Deleting Annotations", deleteAnnotationsToastId);

                try {
                    unwrapResult(await DeleteAnnotations({ AnnotationIds: annotationIds }));
                    ToastClose(deleteAnnotationsToastId);
                    dispatchTable(deselectAllFilteredRows());
                }
                catch (err) {
                    ToastError(err.message, err.cause, deleteAnnotationsToastId);
                }
            }
        }
    }

    function canEditAnnotationSet() {
        return !annotationSet?.IsLocked && CanWriteAnnotationSet(currentUser, annotationSet?.AnnotationSetId, model?.ModelId, project?.ProjectId, project?.OrganisationId);
    }

    function canEditTemplatesOrStyleSheets() {
        return CanEditAnnotationTemplatesOrStyleSheets(currentUser, project?.ProjectId, project?.OrganisationId);
    }


    //edited properties now being saved.
    //foreach selected annotation, make equal to all properties

    async function onSaveProperties(propertyConfig) {

        ToastLoading("Updating Properties", updatePropertiesToastId);

        let success = true;
        //loop over the annotations in the selection
        for (let index = 0; index < propertyConfig.selectedAnnotationIds.length; index++) {

            const annotation = annotationSet?.Annotations.find(a => a.AnnotationId === propertyConfig.selectedAnnotationIds[index]);


            logger.debug("Annotation saving properties", annotation);

            //loop over all the properties returned
            let newProperties = [];
            for (let propertyIndex = 0; propertyIndex < propertyConfig.properties.length; propertyIndex++) {

                logger.debug("Property", propertyConfig.properties[propertyIndex]);

                //is this property on this annotation
                if (propertyConfig.properties[propertyIndex].inAllAnnotations ||
                    propertyConfig.properties[propertyIndex].annotationList.findIndex(a => a === annotation.AnnotationId) > -1) {

                    logger.debug("Property on annotation");

                    let newProperty = (JSON.parse(JSON.stringify(propertyConfig.properties[propertyIndex])));

                    //value hasn't been edited, so use the existing value for this annotation
                    if (!newProperty.valueHasBeenEdited) {

                        //find existing property in this annotation
                        const annotationPropIndex = annotation?.Properties?.findIndex(p => p.PropertyTemplate.PropertyTemplateId === newProperty.PropertyTemplate.PropertyTemplateId);
                        if (annotationPropIndex > -1) {
                            //copy it over - to load existing value
                            newProperty = JSON.parse(JSON.stringify(annotation?.Properties[annotationPropIndex]));
                        }
                    }

                    //make id unique
                    newProperty.PropertyId = uuid();
                    //assign to this annotation
                    newProperty.AnnotationId = annotation.AnnotationId;
                    newProperties.push(newProperty);
                }
            }

            logger.debug("new properties", newProperties);

            try {
                unwrapResult(await UpdateAnnotationProperties(annotation.AnnotationId, newProperties));
            }
            catch (err) {
                ToastError(err.message, err.cause, updatePropertiesToastId);
                success = false;
                setShowPropertiesDialog(true);
                break;
            }
        }
        if (success) {
            ToastClose(updatePropertiesToastId);
            setShowPropertiesDialog(false);
        }



    }

    function deselectAnnotation(annotationId) {
        //deselect the row in the table
        dispatchTable(deselectRow(annotationId));
    }

    //call the edit properties dialog
    function onEditProperties() {


        const selectedData = kaPropsUtils.getSelectedData(tableProps);
        if (selectedData.length > 0) {

            let anParam = { annotations: [] };
            selectedData.forEach(d => {

                //pass all selected annotations to property edit dialog
                const ann = annotationSet?.Annotations.find((a) => a.AnnotationId === d.id);
                anParam.annotations.push(ann);
            });

            setAnnotationPropertiesParam(anParam)
            setShowPropertiesDialog(true);
        }
    }

    const selectedDataLength = kaPropsUtils.getSelectedData(tableProps)?.length;

    function numAnnotationsTitle() {

        return (
            annotationSet?.Annotations ?
                ("(" + annotationSet?.Annotations?.length + ")")
                :
                <></>);

    }

    function numAnnotationsVisibleTitle() {

        return (
            kaPropsUtils.getData(tableProps).length !== annotationSet?.Annotations?.length ?
                ("(Visible: " + kaPropsUtils.getData(tableProps).length + ")")
                :
                <></>);

    }

    function numAnnotationsSelectedTitle() {

        return (
            (selectedDataLength > 0) ?
                ("(Selected: " + selectedDataLength + ")")
                :
                <></>
        );

    }

    function getCsvData() {

        let tableData;

        if (selectedDataLength === 0) {
            tableData = kaPropsUtils.getData(tableProps);
        }
        else {
            tableData = kaPropsUtils.getSelectedData(tableProps);
        }


        let data = [];
        tableData.forEach(d => {
            let entry = {};
            for (const [key, value] of Object.entries(d)) {

                if (key.startsWith("property")) {
                    if (!value?.valid) {
                        entry[key] = "#N/A";
                    }
                    else if (value?.empty) {
                        entry[key] = "";
                    }
                    else if (value?.items) {
                        let list = "";
                        entry[key] = value?.items.map((l, index) => list += l.label + ((index < value.items.length - 1) ? "¦" : ""));
                        entry[key] = list;
                    }
                    else {
                        entry[key] = value?.value;
                    }
                }
                else if (key.startsWith("date")) {
                    if (isNaN(new Date(value)?.getTime())) {
                        entry[key] = "#N/A";
                    }
                    else {
                        entry[key] = value;
                    }
                }
                else if (key.startsWith("user")) {
                    entry[key] = value?.value;
                }
                else if (key !== "id") {
                    entry[key] = value;
                }
                //escape any double quotes
                if (entry[key]) {
                    entry[key] = String(entry[key]).replace(/"/g, '""');
                }
            }
            data.push(entry);
        });

        return data;
    }

    function getCsvHeaders() {
        const data = [];
        tableProps.columns.forEach(c => {
            if (c.key !== 'selection' && c.key !== 'id') {
                data.push({ label: c.title, key: c.key });
            }
        });
        return data;
    }

    function saveJsonData(obj, filename) {

        logger.info("### saveJsonData", obj, filename);

        const blob = new Blob([JSON.stringify(obj, null, 2)], {
            type: "application/json",
        });
        saveAs(blob, filename);
    }

    function makeAnnotationsForJsonExport(annotationIds) {
        let annotations = [];
        annotationSet?.Annotations.forEach(annotation => {
            if (annotationIds.includes(annotation.AnnotationId)) {
                let newAnnotation = JSON.parse(JSON.stringify(annotation));

                //replace points x,y,z with arrays
                newAnnotation.Shape.Points = newAnnotation.Shape.Points.map(p => (
                    {
                        "Point": [p.Point.x, p.Point.y, p.Point.z],
                        "ProjectionDirection": [p.ProjectionDirection.x, p.ProjectionDirection.y, p.ProjectionDirection.z],
                    }));

                newAnnotation.Position = [newAnnotation.Position.x, newAnnotation.Position.y, newAnnotation.Position.z];
                if (newAnnotation?.CameraView?.CameraPosition) {
                    newAnnotation.CameraView.CameraPosition = [newAnnotation.CameraView.CameraPosition.x, newAnnotation.CameraView.CameraPosition.y, newAnnotation.CameraView.CameraPosition.z];
                    newAnnotation.CameraView.CameraRotation = [newAnnotation.CameraView.CameraRotation.x, newAnnotation.CameraView.CameraRotation.y, newAnnotation.CameraView.CameraRotation.z];
                    newAnnotation.CameraView.CentreOfRotation = [newAnnotation.CameraView.CentreOfRotation.x, newAnnotation.CameraView.CentreOfRotation.y, newAnnotation.CameraView.CentreOfRotation.z];
                }

                annotations.push(newAnnotation);
            }
        });
        return annotations;
    }

    function onDownloadJson() {

        //if some are selected export those, otherwise export all

        let annotationIds = [];

        const selectedData = kaPropsUtils.getSelectedData(tableProps);
        if (selectedData.length > 0) {
            //get array of annotation ids
            annotationIds = selectedData.map(item => item.id);
        }
        else {
            annotationIds = annotationSet?.Annotations.map(item => item.AnnotationId);
        }

        saveJsonData(
            {
                "Project": project?.Title,
                "ProjectId": project?.ProjectId,
                "Model": model?.Title,
                "ModelId": model?.ModelId,
                "AnnotationSet": annotationSet?.Title,
                "AnnotationSetId": annotationSet?.AnnotationSetId,
                "CrsId": model?.NativeCrsId,
                "Annotations": makeAnnotationsForJsonExport(annotationIds),
            },
            `${annotationSet?.Title}_annotations.json`);
    }

    return (

        <>
            <div className="view-top-panel">
                <div className="view-title" >
                    Annotations {numAnnotationsTitle()} {numAnnotationsVisibleTitle()} {numAnnotationsSelectedTitle()}
                </div>

                <div className="view-button-panel" >
                    <Button disabled={!canEditAnnotationSet() || selectedDataLength === 0} className="annotation-view-button-panel-button" variant="primary" onClick={onEditProperties}>
                        {kaPropsUtils?.getSelectedData(tableProps)?.length > 1 ? "Edit Properties (All Selected)" : "Edit Properties"}
                    </Button>
                    <Button disabled={!canEditAnnotationSet() || selectedDataLength === 0} className="annotation-view-button-panel-button" variant="primary" onClick={onDeleteSelected}>
                        {kaPropsUtils?.getSelectedData(tableProps)?.length > 1 ? "Delete (All Selected)" : "Delete"}
                    </Button>
                    <Button disabled={!canEditAnnotationSet() || selectedDataLength === 0} className="annotation-view-button-panel-button" variant="primary" onClick={() => setShowCopyAnnotations(true)}>
                        Move/Copy
                    </Button>
                    <Button className="annotation-view-button-panel-button" variant="primary" onClick={onToggleFilter}>{filterVisible ? <RiFilterOffLine /> : <RiFilterLine />}</Button>
                    <Button className="annotation-view-button-panel-button" variant="primary" onClick={onDownloadJson}>{"Download JSON" + (selectedDataLength !== 0 ? " (Selected)" : "")}</Button>
                    <CSVLink
                        data={getCsvData()}
                        headers={getCsvHeaders()}
                        filename='annotations.csv'
                        className="btn btn-primary annotation-view-button-panel-button"
                        target="_blank"
                        enclosingCharacter={`"`}
                    >
                        {"Download CSV" + (selectedDataLength !== 0 ? " (Selected)" : "")}
                    </CSVLink>
                    <Button className="annotation-view-button-panel-button" variant="primary" onClick={() => setShowStyleSheetsDialog(true)}>Style Sheets</Button>
                    <Button disabled={!canEditTemplatesOrStyleSheets()} className="annotation-view-button-panel-button" onClick={() => setShowPropertyTemplatesDialog(true)}>Property Templates</Button>
                </div>
            </div>

            <div className="annotation-table-styles">
                <Table
                    {...tableProps}

                    filteringMode={filterVisible ? FilteringMode.FilterRow : FilteringMode.None}
                    dispatch={dispatchTable}
                    childComponents={{
                        cellText: {
                            content: (props) => {
                                if (props.column.key === "selection" && canEditAnnotationSet()) {
                                    return <SelectionCell {...props} />;
                                }
                                //list type template column
                                //if props.value is not a property object then just display it
                                else if (props.column?.propertyType === "list") {
                                    return <ListCell {...props} />
                                }
                                //value type template column
                                else if (props.column?.propertyType === "number" || props.column?.propertyType === "string" || props.column?.dataType === DataType.String) {
                                    return <ValueCell {...props} />
                                }
                                else if (props.column.dataType === DataType.Date) {
                                    if (isNaN(new Date(props.value)?.getTime())) {
                                        return <>---</>
                                    }
                                }
                            },
                            elementAttributes: () => ({
                                className: 'table-cell-text'
                            })
                        },
                        filterRowCell: {
                            content: (props) => {

                                logger.debug("filterRowCell", props);

                                if ((props.column.key === 'selection' || props.column.key === 'editColumn') && canEditAnnotationSet()) {
                                    return <></>;
                                }
                                else if (props.column.key === 'dateChanged' || props.column.key === 'dateCreated') {
                                    return <FilterDate {...props} />;
                                }
                                else if (props.column.key === 'userChanged' || props.column.key === 'userCreated') {
                                    return <FilterText {...props} />;
                                }
                                else if (props.column?.propertyType === "number") {
                                    return <FilterNumber {...props} />;
                                }
                                else if (props.column?.propertyType === "string") {
                                    return <FilterText {...props} />;
                                }
                                else if (props.column?.propertyType === "list") {
                                    return <FilterList {...props} />;
                                }
                            }
                        },
                        headCell: {
                            elementAttributes: (props) => {
                                if (props.column.key === 'selection' && canEditAnnotationSet()) {
                                    return {
                                        style: {
                                            ...props.column.style,
                                            position: 'sticky',
                                            left: 0,
                                            zIndex: 1,
                                            border: '1px solid #555555',
                                        }
                                    }
                                }
                                else if (props.column.key === 'editColumn' && canEditAnnotationSet()) {
                                    return {
                                        style: {
                                            ...props.column.style,
                                            position: 'sticky',
                                            left: 1,
                                            zIndex: 10,
                                            border: '1px solid #555555',
                                        }
                                    }
                                }
                                else {
                                    return {
                                        style: {
                                            ...props.column.style,
                                            position: 'sticky',
                                            border: '1px solid #555555',
                                        }
                                    }
                                }
                            },
                            content: (props) => {
                                if (props.column.key === 'selection' && canEditAnnotationSet()) {
                                    return (
                                        <SelectionHeader {...props}
                                            areAllRowsSelected={kaPropsUtils.areAllFilteredRowsSelected(tableProps)}
                                        />
                                    );
                                }

                            }
                        },
                        noDataRow: {
                            content: () => 'No Annotations'
                        },
                        cell: {
                            elementAttributes: (props) => {
                                if (props.column.key === 'selection' && canEditAnnotationSet()) {
                                    return {
                                        style: {
                                            ...props.column.style,
                                            position: 'sticky',
                                            left: 0,
                                            backgroundColor: '#ffffff',
                                        }
                                    }
                                }
                            }
                        }
                    }}
                />
            </div>
            <EditAnnotationProperties
                helpContext={annotationPropertiesParam?.annotations?.length === 1 ? BeaconDialogMap.EditSingleAnnotationPropertiesDialog : BeaconDialogMap.EditMultipleAnnotationPropertiesDialog}
                parentHelpContext={helpContext}
                show={showPropertiesDialog}
                setShow={setShowPropertiesDialog}
                onSave={onSaveProperties}
                propertiesParam={annotationPropertiesParam}
                templates={project?.PropertyTemplates}

            />
            <PropertyTemplatesView helpContext={BeaconDialogMap.AnnotationPropertyTemplatesDialog} parentHelpContext={helpContext} project={project} show={showPropertyTemplatesDialog} setShow={setShowPropertyTemplatesDialog} currentUser={currentUser} />
            <StyleSheetsDialog helpContext={BeaconDialogMap.AnnotationStyleSheetsDialog} parentHelpContext={helpContext} project={project} show={showStyleSheetsDialog} setShow={setShowStyleSheetsDialog} currentUser={currentUser} />
            <CopyAnnotationsAround
                helpContext={BeaconDialogMap.CopyAnnotationSetsDialog} parentHelpContext={helpContext}
                show={showCopyAnnotations}
                setShow={setShowCopyAnnotations}
                project={project}
                currentModel={model}
                currentAnnotationSet={annotationSet}
                selectedAnnotationIds={kaPropsUtils?.getSelectedData(tableProps)?.map(item => item.id)}
                deselectAnnotation={deselectAnnotation}
            />

        </>
    );
}

export default AnnotationTable;